import Flatpickr from "stimulus-flatpickr"
import en from "flatpickr/dist/l10n/default"
import { German as de } from "flatpickr/dist/l10n/de"
import MonthSelectPlugin from 'flatpickr/dist/plugins/monthSelect'
import AltInputIdPlugin from '../flatpickr/alt_input_id'

en.rangeSeparator = ' — '
de.rangeSeparator = ' — '

const locales = { en, de }

export default class extends Flatpickr {
  static targets = [ "clearButton" ]

  initialize() {
    super.initialize()

    this.config = {
      locale: locales[document.documentElement.lang || 'de'],
      plugins: []
    }

    this.config.plugins.push(AltInputIdPlugin())

    if (this.data.get("monthSelect")) {
      this.config.plugins.push(new MonthSelectPlugin({ dateFormat: "Y-m" }))
    }
  }

  clearButtonTargetConnected() {
    this.clearButtonTarget.addEventListener("click", this.clear)
  }

  clearButtonTargetDisconnected() {
    this.clearButtonTarget.removeEventListener("click", this.clear)
  }

  ready(selectedDates, dateStr, instance) {
    this._toggleClearButton(dateStr)
    this.autoOpenEnabled && instance.open()
  }

  change(selectedDates, dateStr) {
    this._toggleClearButton(dateStr)
  }

  clear = e => {
    e.preventDefault()
    this.fp.clear()
  }

  _toggleClearButton(dateStr) {
    if (this.hasClearButtonTarget) {
      this.clearButtonTarget.style.display = dateStr ? null : "none"
    }
  }

  get autoOpenEnabled() {
    return [ "open", "true" ].indexOf(this.data.get("open")) >= 0
  }
}
